module.exports = {"TXTACL_Play_Money":{"id":"TXTACL_Play_Money","defaultMessage":"虚拟货币"},"TXTACL_Real_Money":{"id":"TXTACL_Real_Money","defaultMessage":"真实货币"}}